import Vue from "vue";
import VueRouter, { Route, RouteConfig } from "vue-router";
import BaseLayout from "@/views/layout/Base.vue";
import { loadLanguageAsync } from "../i18n";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/:lang",
    component: BaseLayout,
    meta: {
      title: 'Failure Modes | Envalior Engineering Materials',
    },
  },
  {
    path: "*",
    redirect: "/en-US"
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if(nearestWithTitle) { document.title = nearestWithTitle.meta.title; }
  const lang = to.params.lang;
  loadLanguageAsync(lang).then(() => {
    next();
  });
});

export default router;
